import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "grid grid-flow-col auto-cols-max lg:grid-cols-1 xl:grid-cols-2 lg:grid-flow-row lg:auto-cols-auto lg:gap-2 p-0.5 bg-white relative" }
const _hoisted_3 = {
  id: "imageIdx-1",
  class: "w-screen lg:w-full bg-white snap-center lg:snap-align-none",
  style: {"aspect-ratio":"1/1"}
}
const _hoisted_4 = {
  key: 0,
  id: "imageIdxEngraving",
  class: "w-screen lg:w-full bg-white snap-center lg:snap-align-none"
}
const _hoisted_5 = ["id"]
const _hoisted_6 = {
  key: 1,
  class: "hidden lg:block"
}

import ItemImage from "@/components/itemImage.vue";
import ItemEngraving from "@/components/itemEngraving.vue";
import {computed, ref, watch} from "vue";
import {useI18n} from "vue-i18n";
import ItemV2ItemImageBrandLogo from "@/components/itemV2/itemV2ItemImageBrandLogo.vue";

const pageStr = "components.itemV2.itemV2ImageGrid"

/**
 * image idx
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'itemV2ImageGrid',
  props: [
  "image",
  "engraving",
  "imageIdx",
  "popupImage",
  "itemNumber"
],
  emits: [
  "switchImage",
  "popupImage"
],
  setup(__props, { emit: __emit }) {

const {t} = useI18n();
const scrollContainer = ref<HTMLElement | null>(null);
const props = __props;
const emits = __emit;

let isProgrammaticScroll = false;
let timeout: any = null;

const watchScroll = () => {
  if (isProgrammaticScroll || !scrollContainer.value) return;
  getImageInViewport();
}

const brandLogoId = computed(() => {
  return (props.itemNumber.substring(0, 2) == "R-") ? "R" : "S"
})

watch(
    () => props.imageIdx,
    (imageIdx: string | number) => {
      isProgrammaticScroll = true;
      if (timeout) clearTimeout(timeout);

      scrollContainer.value?.querySelector("#imageIdx" + imageIdx)?.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest"
      });

      // Reset the flag after the smooth scroll is likely finished
      timeout = setTimeout(() => {
        isProgrammaticScroll = false;
      }, 500);
    },
    {deep: true},
);

const getImageInViewport = () => {

  // main images
  checkImgaeInViewport("imageIdx-1", "-1")

  // engraving

  if (props.engraving.text != '') {
    checkImgaeInViewport("imageIdxEngraving", "Engraving")
  }

  // image positions

  for (let i = 0; i < props.image.positions.length; i++) {
    checkImgaeInViewport("imageIdx" + i, i.toString())
  }
}

const checkImgaeInViewport = (nodeId: string, imagePoxIdx: string) => {
  const el = scrollContainer.value?.querySelector("#" + nodeId) as HTMLElement;
  if (!el) return;

  const rect = el.getBoundingClientRect();
  const parent = scrollContainer.value; // The scroll container
  if (!parent) return;

  const parentRect = parent.getBoundingClientRect();

  // Check if the center of the element is within the viewport of the scroll container
  const elementCenter = rect.left + rect.width / 2;
  const parentCenter = parentRect.left + parentRect.width / 2;

  // If the element is mostly visible in the center (allowing some margin)
  if (Math.abs(elementCenter - parentCenter) < rect.width / 2) {
    emits('switchImage', imagePoxIdx)
  }
}

const isSetImageExists = computed(() => {
  if (typeof props.image.set === 'undefined' || typeof props.image.set.filename === 'undefined') return false;
  return props.image.set.filename != ""
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "scrollContainer",
    ref: scrollContainer,
    class: _normalizeClass(["w-full overflow-x-auto overflow-y-hidden sticky snap-x snap-mandatory lg:snap-none no-scrollbar scroll-smooth", {
        'fixed insert-0 z-50 h-screen w-screen my-auto content-center': __props.popupImage
      }]),
    onScrollPassive: watchScroll
  }, [
    (__props.popupImage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed bottom-6 right-6 z-50 w-10 h-10",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('popupImage', false))),
          "aria-label": _unref(t)(pageStr + '.close'),
          role: "button"
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            fill: "currentColor",
            class: "size-6"
          }, [
            _createElementVNode("path", {
              "fill-rule": "evenodd",
              d: "M3.22 3.22a.75.75 0 0 1 1.06 0l3.97 3.97V4.5a.75.75 0 0 1 1.5 0V9a.75.75 0 0 1-.75.75H4.5a.75.75 0 0 1 0-1.5h2.69L3.22 4.28a.75.75 0 0 1 0-1.06Zm17.56 0a.75.75 0 0 1 0 1.06l-3.97 3.97h2.69a.75.75 0 0 1 0 1.5H15a.75.75 0 0 1-.75-.75V4.5a.75.75 0 0 1 1.5 0v2.69l3.97-3.97a.75.75 0 0 1 1.06 0ZM3.75 15a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-2.69l-3.97 3.97a.75.75 0 0 1-1.06-1.06l3.97-3.97H4.5a.75.75 0 0 1-.75-.75Zm10.5 0a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-2.69l3.97 3.97a.75.75 0 1 1-1.06 1.06l-3.97-3.97v2.69a.75.75 0 0 1-1.5 0V15Z",
              "clip-rule": "evenodd"
            })
          ], -1)
        ]))], 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createVNode(ItemImage, {
          "image-url": __props.image.filename,
          "image-layer-url": __props.image.filename_layer,
          "main-metal": __props.image.main_metal,
          zoom: true
        }, null, 8, ["image-url", "image-layer-url", "main-metal"])
      ]),
      (__props.engraving.text != '')
        ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
            _createVNode(ItemEngraving, {
              engraving: __props.engraving,
              "main-metal": __props.image.main_metal
            }, null, 8, ["engraving", "main-metal"])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.image.positions, (image_pos, image_pos_idx) => {
        return (_openBlock(), _createElementBlock("li", {
          key: image_pos.filename,
          id: 'imageIdx' + image_pos_idx,
          class: "w-screen lg:w-full bg-white snap-center lg:snap-align-none",
          style: {"aspect-ratio":"1/1"}
        }, [
          _createVNode(ItemImage, {
            "image-url": image_pos.filename,
            "image-layer-url": image_pos.filename_layer,
            "main-metal": __props.image.main_metal,
            zoom: true
          }, null, 8, ["image-url", "image-layer-url", "main-metal"])
        ], 8, _hoisted_5))
      }), 128)),
      ((__props.image.positions.length % 2 != 0 && __props.engraving.text != '') || __props.image.positions.length % 2 == 0)
        ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
            _createVNode(ItemV2ItemImageBrandLogo, {
              "main-metal": __props.image.main_metal,
              brand: brandLogoId.value
            }, null, 8, ["main-metal", "brand"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 34))
}
}

})